import { RouteObject } from 'react-router-dom'
// import Salary from './components/Salary'

import ErrorPage from '@/components/ErrorBoundary/ErrorPage'
import Index from './components/Index'
import List from './components/List'

const WorkDayModule: RouteObject = {
    path: 'workdays',
    children: [
        {
            path: 'manage',
            element: <Index />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

const AccountWorkDayModule: RouteObject = {
    path: 'account/workdays',
    children: [
        {
            path: '',
            element: <List />,
        },
    ],
    errorElement: <ErrorPage status={500} />,
}

export { WorkDayModule, AccountWorkDayModule }
